import { Component, Input, EventEmitter, Output, OnInit, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { getHHMMFromUTCTimeAndTimezoneId, getTimeZonedDateFromUTCTimeAndTimeZoneId, sleepForMS } from '../../helpers/helpers';
import { findTimeZone, getUnixTime } from 'timezone-support';
import { TimeZoneDetails } from 'globals/store/programs.data';
import { DatePickerComponent } from 'src/app/components/misc/date-picker.component';
import { TimeZonePickerComponent } from 'src/app/components/misc/timezone-picker.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'time-selector',
    template: `
<div class="col">
  <h5 class="dateTitle">{{ dateTitle }}</h5>
  <date-picker [pickedDate]="date" (onDateChange)="date = $event; saveTime()"></date-picker>
</div>
<div class="col">
  <h5>{{ timeTitle }}</h5>
  <input #timeInput type="time" id="timeInput" name="time" required (focusout)="saveTime()" />
</div>
<div class="col">
  <ng-container *ngIf="!hideTimeZone">
    <h5>TIME ZONE</h5>
    <timezone-picker *ngIf="!!timezones?.length" [timezones]="timezones" [selectedTimeZoneId]="timeZone" (select)="timeZone = $event.timeZoneId; saveTime()"></timezone-picker>
  </ng-container>
</div>
`,
    styleUrls: ['./time-selector.scss'],
    standalone: true,
    imports: [DatePickerComponent, TimeZonePickerComponent, CommonModule],
})
export class TimeSelectorComponent implements AfterViewInit {
  @Input() timezones: TimeZoneDetails[] = []
  @Input() UTCTime: number
  @Input() timeZone: string
  @Input() hideTimeZone: boolean // still needs timeZone as an input if you hide it for date calculations, but for start time - end time things don't want a timezone select for end time

  @Input() dateTitle = 'PUSH DATE'
  @Input() timeTitle = 'PUSH TIME'
  @Output() timeChange: EventEmitter<{ UTCTime: number, timeZone: string }> = new EventEmitter()
  date: Date

  @ViewChild('timeInput') timeInput: ElementRef<HTMLInputElement>

  async ngAfterViewInit() {
    await sleepForMS(10)
    this.date = getTimeZonedDateFromUTCTimeAndTimeZoneId(this.UTCTime, this.timeZone)
    this.setHHMM()
  }

  setHHMM () {
    this.timeInput.nativeElement.value = getHHMMFromUTCTimeAndTimezoneId(this.UTCTime, this.timeZone)
  }
  
  setTime() {
    const [ hh, mm ] = this.timeInput.nativeElement.value.split(":")
    const time = {
      year: this.date.getFullYear(),
      month: this.date.getMonth() + 1,
      day: this.date.getDate(),
      hours: parseInt(hh),
      minutes: parseInt(mm)
    }
    console.log({ time, date: this.date })
    const timeZoneInfo = findTimeZone(this.timeZone)
    const unixTime = getUnixTime(time, timeZoneInfo)
    this.UTCTime = unixTime
    this.setHHMM()
  }

  saveTime() {
    this.setTime()
    this.timeChange.emit({ UTCTime: this.UTCTime, timeZone: this.timeZone })
  }



}

